import axios from "axios"
const base = "/api/ai-mails"
const request = (method, path = "", data, extra = {}) => axios({ method, url: base + path, data,
  headers: { Authorization: localStorage.getItem("token") }, timeout: 180000, ...extra }).then(response => response.data)
export const mailRef = row => ({ folder: row.folder, uid: row.uid, uidValidity: row.uidValidity, messageId: row.messageId, key: row.key })
export const errorText = error => error?.response?.data?.error || "Der Vorgang konnte nicht abgeschlossen werden. Bitte erneut versuchen."
export const categories = [
  { value: "termination", label: "Kündigung" }, { value: "timestop", label: "Timestop / Abo-Unterbruch" },
  { value: "insurance", label: "Krankenkassenbestätigung" }, { value: "other", label: "Sonstiges / unklar" },
]
export const categoryLabel = value => categories.find(item => item.value === value)?.label || "Noch nicht eingeordnet"
export const formatDate = (value, time = false) => value ? new Intl.DateTimeFormat("de-CH", {
  timeZone: "Europe/Zurich", dateStyle: "medium", ...(time ? { timeStyle: "short" } : {}),
}).format(new Date(value)) : "Noch nicht aktualisiert"
export function download(blob, name) {
  const url = URL.createObjectURL(blob), link = document.createElement("a")
  link.href = url; link.download = name; document.body.appendChild(link); link.click(); link.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
export default {
  list: params => request("get", "", null, { params }), detail: id => request("get", `/${id}`),
  content: id => request("get", `/${id}/content`), scan: () => request("post", "/scan"),
  category: (id, category) => request("patch", `/${id}/category`, { category }),
  classify: id => request("post", `/${id}/classify`), sync: (id, email) => request("post", `/${id}/tac`, { email }),
  reasons: (id, studioId) => request("post", `/${id}/reasons`, { studioId }),
  plan: (id, data) => request("post", `/${id}/plan`, data),
  pdf: (id, data) => request("post", `/${id}/pdf`, data, { responseType: "blob" }),
  terminate: (id, data) => request("post", `/${id}/terminate`, data),
  send: (id, input) => request("post", `/${id}/send`, input),
  folders: () => request("get", "/folders"),
  createFolder: (parent, name) => request("post", "/folders", { parent, name }),
  openMail: ref => request("post", "/mailbox/open", { ref }),
  setRead: (ref, isRead) => request("post", "/mailbox/read", { ref, isRead }),
  mailContent: ref => request("get", "/mailbox/content", null, { params: ref }),
  mailAttachment: (ref, index) => request("get", "/mailbox/attachment", null, { params: { ...ref, index }, responseType: "blob" }),
  move: (ref, target) => request("post", "/mailbox/move", { ref, target }),
  assign: (ref, release = false) => request("post", "/mailbox/assign", { ref, release }),
  sendMail: input => request("post", "/mailbox/send", input),
  attachment: (id, index) => request("get", `/${id}/attachments/${index}`, null, { responseType: "blob" }),
  admin: () => request("get", "/admin"), settings: data => request("put", "/admin/settings", data),
  adminRun: name => request("post", `/admin/${name}`),
}
